/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './component/skip-link.component';
export * from './config';
export * from './directive/skip-link.directive';
export * from './service/skip-link.service';
export { SkipLinkModule } from './skip-link.module';
